import {
  CLEAR_SUBSCRIPTION,
  SUBSCRIPTION_ERROR,
  SUBSCRIPTION_REQUEST,
  SUBSCRIPTION_STATUS_SUCCESS,
  SUBSCRIPTION_SUCCESS,
} from '../Types';

const initialState = {
  activeSubscriptionId: '',
  activeSubscriptionPlanName: '',
  activeSubscriptionStatus: '',
  activePaymentMethod: '',
  activeSubscriptionTier: 0,
  accountPromotionSegment: {},
  hasActiveSubscription: false,
  hasSubscription: false,
  isChangePlanAvailable: false,
  isChurnedRestartAvailable: false,
  isChurnedUser: false,
  isExistingPlanUser: false,
  isFetching: false,
  isFounder: false,
  isIAPUser: false,
  isNewUser: true,
  isPaused: false,
  isPendingPause: false,
  isPendingCancel: false,
  isSuccess: false,
  isStatusSuccess: false,
  isTrialistUser: false,
  nextSubscription: null,
  pauseEndDate: 0,
  pauseStartDate: 0,
  purchaseType: '',
  restartChurnedUserDetails: {},
  validityTill: 0,
};

export const subscription = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isSuccess: true,
        isFetching: false,
        ...action.payload,
      };
    case SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: action.payload,
        isSuccess: true,
        isFetching: false,
      };
    case SUBSCRIPTION_STATUS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isStatusSuccess: true,
      };
    case CLEAR_SUBSCRIPTION:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
